if(!customElements.get('custom-hero')){
    class CustomHero extends HTMLElement {
        constructor(){
            super();
            this.currentSlide = 1;
            this.totalSlides  = 0;
            this.isAnimating  = false;
            this.autoPlayTimer = null;
            this.init();
        }

        init(){
            this.initVideo();
            this.initSlider();
            // this.adjustPaddingTop();
            // this.adjustHeight();
            //document.addEventListener('scroll', this.adjustPaddingTop.bind(this), false);
            // document.addEventListener('scroll', this.adjustHeight.bind(this), false);
        }

        refresh(){
            this.init();
        }

        initVideo(){
            this.videos = this.querySelectorAll('video');
            this.videoPlaceholders = this.querySelectorAll('.hero__bg--slide-placeholder');
            this.videos.forEach(video => {
                const loadVideos = () => {
                    video.classList.add('loaded');
                    const idx = video.dataset.idx;
                    this.videoPlaceholders.forEach(item => {
                        if(item.dataset.idx === idx){
                            item.classList.add('loaded-video');
                        }
                    });
                };
                video.addEventListener('loadeddata', loadVideos);
                if(video.readyState >= 2) loadVideos();
            });
        }

        initSlider(){
            this.slides      = Array.from(this.querySelectorAll('.hero__slide'));
            this.bullets     = Array.from(this.querySelectorAll('.hero__slide-pagination-bullet'));
            this.totalSlides = this.slides.length;

            if(this.totalSlides < 2) return;

            // Build bg groups — one per slide index
            this.bgGroups = [];
            for(let i = 1; i <= this.totalSlides; i++){
                // Collect ALL elements that belong to slide i
                // desktop img, mobile img, video, placeholder svg
                const els = Array.from(this.querySelectorAll(
                    `.hero__bg--slide${i}`
                ));
                this.bgGroups.push(els);
            }

            // ── Set initial states ─────────────────────────────────────
            this.slides.forEach((slide, i) => {
                slide.style.transition = 'none';
                slide.style.opacity    = i === 0 ? '1' : '0';
                slide.style.zIndex     = i === 0 ? '2' : '0';
                slide.style.transform  = 'translateX(0)';
            });

            this.bgGroups.forEach((group, i) => {
                group.forEach(el => {
                    el.style.transition = 'none';
                    el.style.position   = 'absolute';
                    el.style.top        = '0';
                    el.style.left       = '0';
                    el.style.width      = '100%';
                    el.style.height     = '100%';
                    el.style.opacity    = i === 0 ? '1' : '0';
                    el.style.transform  = i === 0 ? 'translateX(0%)' : 'translateX(100%)';
                    el.style.zIndex     = i === 0 ? '1' : '0';
                });
            });

            // ── Bullet clicks ──────────────────────────────────────────
            this.bullets.forEach(bullet => {
                bullet.addEventListener('click', () => {
                    const idx = parseInt(bullet.getAttribute('data-idx'));
                    this.goToSlide(idx);
                });
            });

            // ── Touch swipe ────────────────────────────────────────────
            let touchStartX = 0;
            this.addEventListener('touchstart', e => {
                touchStartX = e.touches[0].clientX;
            }, { passive: true });

            this.addEventListener('touchend', e => {
                const diff = touchStartX - e.changedTouches[0].clientX;
                if(Math.abs(diff) > 50){
                    if(diff > 0){
                        this.goToSlide(this.currentSlide >= this.totalSlides ? 1 : this.currentSlide + 1);
                    } else {
                        this.goToSlide(this.currentSlide <= 1 ? this.totalSlides : this.currentSlide - 1);
                    }
                }
            }, { passive: true });

            // ── Auto-play ──────────────────────────────────────────────
            this.startAutoPlay();

            // ── Set first bullet active ────────────────────────────────
            this.updateBullets(1);
        }

        goToSlide(index){
            if(this.isAnimating || index === this.currentSlide) return;
            this.isAnimating = true;

            const direction = 1;
            const prevIdx   = this.currentSlide - 1;
            const nextIdx   = index - 1;

            const prevSlide = this.slides[prevIdx];
            const nextSlide = this.slides[nextIdx];
            const prevBg    = this.bgGroups[prevIdx];
            const nextBg    = this.bgGroups[nextIdx];

            const dur    = '0.7s';
            const ease   = 'cubic-bezier(0.77, 0, 0.175, 1)';
            const trans  = `transform ${dur} ${ease}, opacity ${dur} ${ease}`;

            // ── Position next elements off-screen ──────────────────────
            if(nextSlide){
                nextSlide.style.transition = 'none';
                nextSlide.style.transform  = `translateX(${direction * 100}%)`;
                nextSlide.style.opacity    = '1';
                nextSlide.style.zIndex     = '1';
            }

            nextBg && nextBg.forEach(el => {
                el.style.transition = 'none';
                el.style.transform  = `translateX(${direction * 100}%)`;
                el.style.opacity    = '1';
                el.style.zIndex     = '1';
            });

            // Force reflow
            this.getBoundingClientRect();

            // ── Slide OUT current ──────────────────────────────────────
            if(prevSlide){
                prevSlide.style.transition = trans;
                prevSlide.style.transform  = `translateX(${-direction * 100}%)`;
                prevSlide.style.opacity    = '0';
                prevSlide.style.zIndex     = '0';
            }

            prevBg && prevBg.forEach(el => {
                el.style.transition = trans;
                el.style.transform  = `translateX(${-direction * 100}%)`;
                el.style.opacity    = '0';
                el.style.zIndex     = '0';
            });

            // ── Slide IN next ──────────────────────────────────────────
            if(nextSlide){
                nextSlide.style.transition = trans;
                nextSlide.style.transform  = 'translateX(0%)';
                nextSlide.style.opacity    = '1';
                nextSlide.style.zIndex     = '2';
            }

            nextBg && nextBg.forEach(el => {
                el.style.transition = trans;
                el.style.transform  = 'translateX(0%)';
                el.style.opacity    = '1';
                el.style.zIndex     = '1';
            });

            // ── Update bullets & state ─────────────────────────────────
            this.updateBullets(index);
            this.currentSlide = index;

            setTimeout(() => {
                this.isAnimating = false;
            }, 750);

            // Reset autoplay
            this.startAutoPlay();
        }

        updateBullets(index){
            this.bullets.forEach(b => {
                b.removeAttribute('data-active');
                b.style.height = '10px';
            });
            const active = this.querySelector(
                `.hero__slide-pagination-bullet[data-idx="${index}"]`
            );
            if(active){
                active.setAttribute('data-active', 'true');
                active.style.height = '30px';
            }
        }

        startAutoPlay(){
            if(this.autoPlayTimer) clearInterval(this.autoPlayTimer);
            this.autoPlayTimer = setInterval(() => {
                const next = this.currentSlide >= this.totalSlides
                    ? 1
                    : this.currentSlide + 1;
                this.goToSlide(next);
            }, 5000);
        }

        adjustPaddingTop(){
            var header = document.querySelector('custom-header');
            if(header){
                setTimeout(() => {
                    var headerHeight = header.offsetHeight;
                    if(document.querySelector('custom-announcement-bar')){
                        headerHeight += document.querySelector('custom-announcement-bar').offsetHeight;
                    }
                    this.querySelectorAll('.hero__slide').forEach(item => {
                        item.style.paddingTop = `${headerHeight}px`;
                    });
                }, 500);
            }
        }

        /*adjustHeight(){
            var maxHeight = 0;
            this.querySelectorAll('.hero__slide').forEach(item => {
                maxHeight = Math.max(maxHeight, item.offsetHeight);
            });
            this.style.height = `${maxHeight}px`;
            const bgWrapper = this.querySelector('.hero__bg-wrapper');
            if(bgWrapper && bgWrapper.dataset.slideSize == "1"){
                bgWrapper.style.minHeight = `${maxHeight}px`;
            }
        }*/
    }

    customElements.define('custom-hero', CustomHero);
}